import form from "../Form.module.css";
import cn from "classnames";
import { Tooltip } from "components/Tooltip/Tooltip";
import { IconChevronUp } from "components/Icons/IconChevronUp";
import { IconChevronDown } from "components/Icons/IconChevronDown";

import { useState } from "react";

import type { FormState } from "../FormState";
import type { Dispatch, SetStateAction } from "react";

interface Props<FState> {
  state: FState;
  setState: Dispatch<SetStateAction<FState>>;
}

export function FieldTimezone<FState extends FormState>(_props: Props<FState>) {
  const [isOpen] = useState(false);

  return (
    <label className={cn(form.label, form.disabled)}>
      <span>Timezone</span>

      <Tooltip position="below-center" label="More timezones coming soon!">
        <button type="button" disabled>
          <span className={form.fieldText}>UTC</span>
          {!isOpen ? <IconChevronDown /> : <IconChevronUp />}
        </button>
      </Tooltip>
    </label>
  );
}
